import React from "react";
import { Paper, Typography, Grid, CircularProgress, Chip, makeStyles, Badge, CardActionArea } from "@material-ui/core";
import { Person, SupervisorAccount } from "@material-ui/icons";
import { Link } from "react-router-dom";

const useStyles = makeStyles(() => ({
  messageTextTypo: {
    color: "#757575",
    fontSize: "14px",
    marginTop: "5px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "400px",
  },
}));

const RecentMessages = (props) => {
  const { loading, recentMessages = [] } = props;
  const classes = useStyles();

  return (
    <Grid item xs={12}>
      <Paper style={{ padding: 15 }}>
        <Typography style={{ fontWeight: "bold", fontSize: "15px" }}>آخرین پیام ها</Typography>

        <Grid
          container
          style={{
            overflow: "auto",
            maxHeight: "200px",
            marginTop: 10,
            // maxWidth: "600px",
          }}
        >
          {loading ? (
            <Grid container alignItems='center' alignContent='center' justifyContent='center'>
              <CircularProgress style={{ color: "#757575" }} />
            </Grid>
          ) : !(recentMessages.length > 0) ? (
            <Grid container alignItems='center' alignContent='center' justifyContent='center'>
              <Chip variant='outlined' label='پیامی برای نمایش وجود ندارد!' style={{ margin: 20 }} />
            </Grid>
          ) : (
            recentMessages.map((mes) => {
              const date = new Date(mes.created_at);
              const today = new Date();
              const yesterday = new Date();
              yesterday.setDate(today.getDate() - 1);
              return (
                <Grid item xs={12} style={{ paddingTop: 10, paddingRight: 20 }}>
                  <Badge
                    color='error'
                    badgeContent={"جدید"}
                    overlab='circle'
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    style={{ width: "100%" }}
                    invisible={date.getTime() > today.getTime() || date.getTime() <= yesterday.getTime()}
                  >
                    <Paper
                      variant='outlined'
                      style={{
                        overflow: "hidden",
                        marginLeft: 20,
                        width: "100%",
                      }}
                    >
                      <CardActionArea
                        component={Link}
                        to='/panel/messages'
                        style={{
                          padding: 10,
                          width: "100%",
                        }}
                      >
                        <Grid container direction='row'>
                          <Typography style={{ fontSize: 15, marginLeft: 10 }}>
                            {mes.user.first_name + " " + mes.user.last_name}
                          </Typography>
                          {mes.user.role === "admin" && (
                            <Chip color='secondary' size='small' icon={<SupervisorAccount />} label='مدیر' />
                          )}
                          {mes.user.role === "user" && (
                            <Chip color='secondary' size='small' icon={<Person />} label='کاربر' />
                          )}
                        </Grid>

                        <Typography className={classes.messageTextTypo}>{mes.text}</Typography>
                      </CardActionArea>
                    </Paper>
                  </Badge>
                </Grid>
              );
            })
          )}
        </Grid>
      </Paper>
    </Grid>
  );
};
export default RecentMessages;
